<template>
  <div v-if="!data.delete" class="dashboard-fieldset mb-lg shadow">
    <div>
      <div>
        <Button
          v-on:button-click="askConfirmation"
          type="button"
          bType="text"
          bTextColor="red"
          bSize="slim"
          class="fl-right"
        >
          Delete<i
            class="fa fa-times-circle ml-xs"
            aria-hidden="true"
            style="margin-left:5px;"
          ></i>
        </Button>
      </div>

      <div
        class="grid__cell col12-of-12--small col12-of-12--medium col12-of-12--large-up"
        style="padding-right: 0.75em;"
      >
        <label>
          Badge name
          <input
            data-hj-allow
            @change="
              $emit('update-item', {
                value: $event.target.value,
                key: 'name',
                index: data.order,
              })
            "
            placeholder="Badge Name"
            :value="data.name"
            type="text"
          />
        </label>
        <FileUploadZone
          :existing-img="data.logo || undefined"
          zone-text="For best results, use 280x140 transparent PNG image"
          @update-image="changeBadge"
          field="imageUrl"
          accept=".png, .jpg, .jpeg, .gif"
        ></FileUploadZone>
      </div>
    </div>
    <Modal
      v-if="showModal"
      okText="Delete"
      cancelText="Close"
      header="Delete badge"
      body="This action cannot be undone and will impact all partners connected to this badge, are you sure you want to delete this?"
      @cancel="showModal = false"
      @confirm="deleteItem"
    />
  </div>
</template>

<script>
import Modal from '@/components/Modal';
import FileUploadZone from '@/components/Dashboard/FileUploadZone';
import Button from '@/components/DesignSystem/Button';

export default {
  components: {
    FileUploadZone,
    Modal,
    Button,
  },
  props: {
    data: Object,
    index: Number,
  },
  data() {
    return {
      showing: true,
      showModal: false,
    };
  },
  methods: {
    askConfirmation() {
      this.showModal = true;
    },
    changeBadge(payload) {
      const { file } = payload;
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onloadend = () => {
          return this.$emit('update-item', {
            index: this.data.order,
            key: 'logo',
            value: reader.result,
          });
        };
      }
      return this.$emit('update-item', {
        index: this.data.order,
        key: 'logo',
        value: undefined,
      });
    },
    deleteItem() {
      this.showModal = false;
      this.$emit('delete-item', this.data.order);
    },
  },
};
</script>
